import logger from '../../utils/logger';
import { api } from './client';

export const sensorProvisioningApi = {
  detectFromSerial: async (serialNumber: string) => {
    logger.log('📡 Detecting sensor from serial:', serialNumber);
    const response = await api.post('/devices/detect-from-serial', {
      serialNumber,
    });
    return response.data;
  },

  createFromSerial: async (payload: {
    serialNumber: string;
    deviceName: string;
    siteId: string;
    zoneId?: string;
    selectedMetrics: string[];
    alarmRule?: {
      highThreshold: number;
      lowThreshold: number;
      hysteresis?: number;
      debounceSeconds?: number;
      cooldownMinutes?: number;
      severity?: 'low' | 'medium' | 'high' | 'critical';
      notificationsEnabled?: boolean;
    };
  }) => {
    logger.log('📡 Creating device from serial:', payload.serialNumber);
    const response = await api.post('/devices/create-from-serial', payload);
    return response.data;
  },

  getUnmappedSensors: async (orgId?: string) => {
    logger.log('📡 Fetching unmapped sensors', orgId ? `for org: ${orgId}` : '');
    const response = await api.get('/devices/unmapped-sensors', {
      params: { orgId },
    });
    return response.data;
  },
};
